var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-app-bg",staticStyle:{"height":"100vh","text-align":"center"}},[_c('h2',[_vm._v("Processing Invitation...")])])}]

export { render, staticRenderFns }